import { Sparkline } from "../primitives/Sparkline";
import { cn } from "../../lib/cn";

interface VitalSparklineProps {
  label: string;
  data: number[];
  color?: string;
  format?: (value: number, index: number) => string;
  className?: string;
}

function VitalSparkline({
  label,
  data,
  color = "var(--color-lever-orange)",
  format,
  className,
}: VitalSparklineProps) {
  const current = data.length > 0 ? data[data.length - 1] : 0;

  return (
    <div className={cn(
      "flex items-center gap-3 rounded-[var(--radius-md)] px-3 py-2",
      "bg-[var(--bg-surface)] border border-[var(--border-hairline)]",
      className,
    )}>
      <div className="flex-1 min-w-0">
        <span className="text-[9px] font-medium uppercase tracking-wider text-[var(--text-muted)] block">
          {label}
        </span>
        <span className="text-sm font-semibold text-[var(--text-primary)] tabular-nums">
          {format ? format(current, data.length - 1) : current.toLocaleString()}
        </span>
      </div>
      <Sparkline
        data={data}
        width={80}
        height={24}
        strokeColor={color}
        fillColor={color}
        strokeWidth={1.5}
        format={format}
      />
    </div>
  );
}

VitalSparkline.displayName = "VitalSparkline";

export { VitalSparkline };
export type { VitalSparklineProps };
